import * as types from './mutation_types'

export default {
  // 设置用户信息
  [types.SET_USER_INFO] (state, payload) {
    state.userInfo = payload
  }
}
